/**
 * Client-side locale hints from IANA timezone (no network).
 * Mirrors Mazuu Faida’s East Africa / French-region fallbacks when browser is generic English
 * and IP/geo is slow or unavailable.
 */

/** Kiswahili corridor: TZ/KE. Uganda uses English per Tcards country mapping — exclude Kampala. */
export function inferRegionalLangFromTimeZone(): 'sw' | 'fr' | null {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return null;
    const t = tz.toLowerCase();

    if (t.includes('kampala')) return null;

    if (
      t.includes('dar_es_salaam') ||
      t.includes('nairobi') ||
      t.includes('zanzibar') ||
      t.includes('mogadishu') ||
      t.includes('juba')
    ) {
      return 'sw';
    }

    if (
      t.includes('paris') ||
      t.includes('douala') ||
      t.includes('kinshasa') ||
      t.includes('dakar') ||
      t.includes('abidjan') ||
      t.includes('casablanca') ||
      t.includes('tunis')
    ) {
      return 'fr';
    }

    return null;
  } catch {
    return null;
  }
}
